const messages = {
  es: {
    translations: {
      auth: {
        signIn: 'Entrar',
        signUp: 'Registrarse',
        forgotPassword: 'Olvido la contraseña?',
      },
      login: {
        welcome: '¡Bienvenido de nuevo!',
        username: 'Correo electrónico',
        password: 'Contraseña',
      },
      firebase: {
        successOnGetToken: 'Notificaciones configuradas correctamente.',
        dontHaveServiceWorker: 'No pudimos obtener la autorización para recibir notificaciones.',
        errorOnGetToken:
          'Hubo un error al obtener la autorización para que pueda recibir notificaciones, por favor intente de nuevo.',
        requestPermission:
          'No se puede obtener autorización para enviar notificaciones, habilite el permiso para que las notificaciones funcionen correctamente.',
      },
      laboratory: {
        modal: {
          title: 'Alerta',
          message: 'Su navegador no es compatible con la API gráfica "WebGL 2.0" requerida para este contenido, por lo tanto, no es posible mostrar la experiencia de laboratorio en su navegador.',
          okButton: 'Vuelve',
        },
      },
      live: {
        isPlaying: 'Auditorio / En vivo',
        isNextLive: 'Auditorio / Siguiente Vivo',
        isLastLive: 'Auditorio / Previo Vivo',
        isUnknown: 'Auditorio / Desconocido',
        past: 'Vivo Anteriores',
        future: 'Vivo Futuras',
        new: 'Nuevo',
        livenow: 'VIVE AHORA',
        liveNext: 'PRÓXIMO EN VIVO',
        loadMore: 'Carga más',
        scheduled: 'Programado para',
        leaveFeedback: 'Deje sus comentarios',
        successFeedback: 'Comentarios enviados',
      },
      modals: {
        levelUp: {
          title: 'NUEVO NIVEL!',
          continue: 'Continuar',
          level: 'Nivel',
          yourLevel: 'Ahora estás en',
        },
        reward: {
          continue: 'Continuar',
          received: 'Recibiste la siguiente experiencia',
          points: 'puntos',
          wrong: 'Respuesta incorrecta',
        },
        profile: {
          progressTitle: 'SU PROGRESO EN LAS PISTAS',
          downloadCertificate: 'Descargar certificado',
        },
        notifications: {
          pending: 'notificaciones pendientes',
          seeAll: 'Ver todo',
          title: 'Notificaciones',
          loadMore: 'Carga más',
        },
        cards: {
          title: 'Tarjetas',
          ready: 'Dispuesto',
          back: 'Vuelve',
          cardPlaceholderAlt: 'La posición donde estará la tarjeta.',
          rewardIconPlaceholderAlt: 'La imagen de la recompensa del bien o del mal.',
          rightAnswer: '¡ES CORRECTO!',
          wrongAnswer: '¡INCORRECTO!',
        },
        roulette: {
          title: 'RULETA',
          rouletteWheelBackAlt: 'La parte trasera de la rueda de la ruleta.',
          rouletteWheelFrontAlt: 'La parte delantera de la rueda de la ruleta.',
          rouletteWheelMarkerAlt: 'La parte que señala qué opción se seleccionó.',
          rouletteWheelBotAlt: 'Haga clic aquí para hacer girar la rueda.',
          rouletteWheelStandAlt: 'La base de apoyo para la ruleta.',
        },
        places: {
          materialUrl: 'Material',
          mediaImageAlt: 'Los medios de la imagen del lugar.',
        },
        tracks: {
          reward: 'Recompensa',
        },
        feedbacks: {
          title: 'Comentarios',
          ratingLabel: '¿Cómo evalúa este seminario web?',
          contactLabel: '¿Le gustaría recibir un contacto de nuestro equipo para obtener más información?',
          observationsLabel: 'Si tiene comentarios o temas sugeridos para nuevos seminarios web, informe aquí.',
          observationsPlaceholder: 'Ingrese su comentario',
          sendButton: 'Enviar',
        },
        finishedTrack: {
          title: 'Felicidades!',
          congratulations:
            'Ha completado con éxito esta pista, ahora puede obtener la certificación al iniciar sesión en su perfil o darnos su opinión sobre lo que piensa de esta experiencia.',
          giveFeedback: 'Deje sus comentarios',
          openProfile: 'Ver perfil',
          back: 'Vuelve',
          lab: 'Ir al Laboratorio',
        },
        lounge: {
          title: 'Salón',
        },
        doubt: {
          title: 'Dudas',
          description: '¿Aún tienes dudas? Si es necesario, comuníquese con nosotros o, si lo prefiere, vuelva a hacer clic en el botón del tutorial para volver a realizar el tutorial y aprender a utilizar correctamente la plataforma.',
          support: 'Entre en contacto',
          tutorial: 'Retomar el tutorial',
          back: 'Vuelve',
        },
      },
      ranking: {
        loadMore: 'Carga más',
        rules: 'Reglas',
        guide: '/assets/documents/Ranking y premios en Neles Experience Days.pdf',
        finished: 'Clasificación cerrada, conoce a los ganadores en primeiro, segundo y terceiro lugar',
      },
      tracks: {
        description:
          'Después de ver todo el material necesario, tomará una prueba, ¡responda correctamente para ganar puntos!',
        slides: 'Diapositiva',
        quiz: 'Responder cuestionario',
        youNeedWatchVideo: '¡Debes ver al menos el 50% del video para continuar con el siguiente paso!',
        mediaImageAlt: 'Los medios de la imagen de la pista.',
        downloadSoftware: 'Descargar Software',
        materialUrl: 'Descargar Material',
      },
      places: {
        title: 'Equipo',
        materials: 'Materiales',
        mediaImageAlt: 'Los medios de imagen del equipo.',
      },
      register: {
        welcome: '¡Bienvenidos, creemos su cuenta!',
        username: 'Nombre',
        lastName: 'Apellido',
        email: 'Correo electrónico',
        password: 'Contraseña',
        enterprise: 'Compañia',
        industry: 'Indústria',
        language: 'Idioma',
        country: 'País',
        department: 'Departamento',
        send: 'Seguir',
        next: 'Siguiente',
        back: 'Volver',
        terms:
          'Al hacer clic en el botón "Seguir", acepta recibir comunicaciones de Neles y nuestros socios de servicio sobre servicios, promociones y eventos que creemos que le interesarán.',
        industries: {
          chemistry: 'Química',
          energy: 'Energía',
          gasProcessing: 'Procesamiento de Gas y GNL',
          industrialGas: 'Gas industrial',
          processingOfMinerals: 'Minería y procesamiento de minerales',
          transportPipe: 'Tubería de transporte',
          paperBioProductsAndCellulose: 'Pulpa, Papel y Bioproductos',
          refinery: 'Refinería',
          others: 'Otras industrias de proceso',
        },
        departments: {
          projectEngineering: 'Ingeniería de proyectos',
          executiveManagement: 'Gerencia executiva',
          maintenance: 'Mantenimiento',
          processEngineering: 'Ingeniería de Proceso/Controle',
          control: 'Mantenimiento',
          production: 'Producción',
          supplies: 'Suministos',
          students: 'Estudiante',
          academy: 'Academico',
          sellsAndMarketing: 'Ventas y Marketing',
          others: 'Otros',
        },
      },
      buttons: {
        login: 'Entrar',
        register: 'Continuar',
      },
      menu: {
        map: 'Mapa',
        auditorium: 'Sala',
        doubts: 'Dudas',
        lives: {
          future: 'Reuniones Futuras',
          latest: 'Reuniones Anteriores',
          now: 'Live',
        },
        training: {
          title: 'Capacitación',
          lab: 'Laboratorio',
        },
        lounge: 'Programar reunión',
        notifications: 'Notificaciones',
        configurations: 'Ajustes',
        loading: 'Cargando Senderos...',
        alreadyFinishedTrack: 'Has completado el recorrido, ¡ahora puedes descargar tu certificado!',
      },
      error: {
        error: 'Oops...',
        success: 'Éxito!',
        cannotSyncUser: 'Se produjo un error al sincronizar la información del usuario.',
        cannotUpdateUser: 'No se puede actualizar la información del usuario.',
        cannotCreateUser: 'No se puede realizar la creación del usuario, inténtelo de nuevo.',
        cannotGetUserInfo: 'No se puede obtener su información de usuario, vuelva a intentarlo.',
        cannotLogin: 'Su correo electrónico o contraseña no son correctos.',
        defaultMessage: 'Disculpe, ocurrió un error inesperado.',
        cannotSentEmail: 'No se pudo enviar el correo de recuperación.',
        cannotResetPassword: 'No se puede restablecer su contraseña.',
      },
      config: {
        title: 'Ajustes',
        sound: {
          title: 'Volumen de Sonido',
          withoutSound: 'Sin Sonido',
          lower: 'Bajo',
          normal: 'Normal',
          medium: 'Promedio',
          high: 'Elevado',
        },
        soundOff: 'El icono de sonido silenciado.',
        soundOn: 'El icono de sonido.',
        interface: {
          title: 'Escala de Interfaz',
          tiny: 'Menor',
          little: 'Pequeño',
          default: 'Estándar',
          great: 'Estupendo',
        },
        language: 'Lenguaje',
        editProfile: 'Editar Perfil',
        credits: 'Créditos',
        logout: 'Cerrar Sesión',
        profile: {
          title: 'EDITAR PERFIL',
          namePlaceholder: 'Nombre',
          save: 'ENVIAR',
          successMessage: '¡Tu nombre de usuario se ha actualizado correctamente!',
        },
      },
      tour: {
        step0: '¡Bienvenido a Neles Experience Days! ¡Vamos allá!',
        step1: 'Aquí puedes emitir el próximo directo.',
        step2: 'A través de la Sala puede ponerse en contacto con Neles.',
        step3: 'Seleccione una pista para ver los módulos y obtenga su certificado.',
        step4: 'En el mapa puedes ver los senderos, lugares, vidas y salón.',
        step5: 'En el auditorio tienes acceso a vidas pasadas, vivas y futuras.',
        step6: 'En la formación tienes acceso a las pistas y al laboratorio.',
        step7: '¡Aquí puedes consultar el ranking de los usuarios con más puntos!',
        step8: '¡Aquí puedes ponerte en contacto con Neles!',
        step9: '¡Aquí puede verificar las notificaciones de Neles por usted!',
        step10: 'En la pestaña de configuración puede ajustar la configuración del sistema.',
        done: '¡Entendido!',
      },
      forgot: {
        welcome: 'Restablecer contraseña por Correo Electrónico',
        emailCouldNotBeSent: 'Hubo un problema y no se envió el correo electrónico. Vuelva a intentarlo.',
        emailWasSentSuccess: '¡Correo electrónico de recuperación enviado correctamente!',
        email: 'Correo electrónico',
        sent: 'Enviar',
      },
      reset: {
        welcome: 'Restablecer la contraseña',
        success: '¡Su contraseña ha sido restablecida con éxito!',
        password: 'Introduzca una nueva contraseña',
        sent: 'Enviar',
      },
    },
  },
};

export { messages };
